<template>
  <el-drawer v-model="is_show_drawer" :size="width" class="manage-content-drawer"
    :class="['manage-content-' + manage_type]" :destroy-on-close="true" :with-header="false">
    <header class="head">
      <i @click="close"><svg-icon name="close2" /></i>
      <h2>Manage {{ heading }}
      </h2>
      <span v-if="selected_items.length !== 0">Selected ({{ selected_items.length }})</span>
    </header>
    <div class="list-wrap" v-loading="is_loading">
      <template v-if="!is_loading && items.length !== 0">
        <drop-list class="item-list" :items="items" :class="{ 'is-sorting': is_sorting }" @reorder="$event.apply(items)"
          v-loading="is_update_data">
          <template v-slot:item="{ item, index }">
            <drag :key="item.id" :scrolling-edge-size="-1000" handle=".drag-handle" @dragstart="dragStart(index, item)"
              @dragend="dragEnd(index, item)">
              <component :is="getComponentType(item)" :item="item" :is_tag="true"
                :is_home="route.params.type === 'featured'" :is_in_post="props.manage_type === 'post'"
                :is_in_collection="props.manage_type === 'collection'" @delete-product="deleteItems"
                @select="selectItem" />
            </drag>
          </template>

          <template v-slot:feedback>
            feedback
          </template>
        </drop-list>

        <div v-if="is_loading_next" style="height: 120px;" v-loading="is_loading_next"></div>
        <div class="load-more" v-if="!is_loading && !is_loading_next && items.length !== 0 && !is_end">
          <el-button @click="updateData(true)" type="primary" size="large">
            Load more
          </el-button>
        </div>
      </template>
      <p v-if="items.length !== 0 && is_end" class="is-end">No more items to show</p>
    </div>
    <manage-tools :key="props.manage_type" :is_organize="true" :selected_items="selected_items"
      :is_selected_all="selectedAll" :manage_type="props.manage_type" @deselect-all="selectItem('deselect-all')"
      @select-all="selectItem('select-all')" @hide="publishItems('hide')" @publish="publishItems('publish')"
      @delete="deleteItems" @unfeature="unfeature" @move-up="moveItems('top')" @move-down="moveItems('last')"
      @open-chronological-menu="chronological_menu_el.open()" />
  </el-drawer>
  <confirm-dialog ref="confirm_dialog_el" :data="confirm_data" />
  <chronological-menu ref="chronological_menu_el" @sort="chronological" :sort_type="sort_type" />
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { Drag, DropList } from 'vue-easy-dnd';
import ProductItem from './ProductItem.vue';
import ManageTools from './ManageTools.vue';
import { useNotification } from '@/components/ui/notification';
import ConfirmDialog from './ConfirmDialog.vue';
import { useStore } from 'vuex';
import { ElDrawer, ElButton } from 'element-plus';

const props = defineProps({
  manage_type: {
    type: String,
    default: ''
  },
  manage_content_id: {
    type: Number,
    default: 0
  }
});
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const event = app.appContext.config.globalProperties.EventBus;
const store = useStore();
const { openNotBottom } = useNotification();
const emit = defineEmits(['move', 'delete', 'update']);
const is_show_drawer = ref(false);
const is_loading = ref(false);
const is_update_data = ref(false);
const is_loading_next = ref(false);
const heading = ref('');
const items = ref([]);
const route = useRoute();
const confirm_dialog_el = ref(null);
const chronological_menu_el = ref(null);
const confirm_data = ref({
  title: '',
  description: '',
  action: () => { },
});

// const router = useRouter();
const paged = ref(1);
const is_end = ref(false);
const is_sorting = ref(false);
const width = ref('100%');
const sort_type = ref(0);

let drag_pre_index = -1;
const collection_value = ref({});
const storefront = computed(() => {
  return store.state.user_data.merchant_account;
});
//+++++++++++++++++++++++++++++++++++++++++++++++
const getComponentType = (item) => {
  // switch (item.type) {
  //   case 'product':
  //     return ProductItem;
  //   case 'post':
  //     return PostItem;
  //   case 'collection':
  //     return CollectionItem;
  // }
  return ProductItem;
};

const selectItem = (item) => {
  switch (item) {
    case 'select-all':
      items.value.forEach((item) => {
        if (item.type === 'product' && store.project === 'sephora' && item.product_detail.availability === 0) return;
        item.is_selected = true;
      });
      break;

    case 'deselect-all':
      items.value.forEach((item) => item.is_selected = false);
      break;

    default:
      item.is_selected = !item.is_selected;
      break;
  }
};

const selectedAll = computed(() => {
  if (store.project === 'sephora') {
    const items_length = route.params.type === 'products' ? items.value.filter((item) => item.product_detail.availability !== 0).length : items.value.length;
    return selected_items.value.length === items_length;
  }

  return selected_items.value.length === items.value.length;
});

const selected_items = computed(() => {
  return items.value.filter((item) => item.is_selected);
});

const updateData = (is_next = false) => {
  let api = '';

  if (is_next) {
    is_loading_next.value = true;
    paged.value++;
  } else {
    is_loading.value = true;
    paged.value = 1;
    is_end.value = false;
    items.value = [];
  }


  heading.value = 'products';
  api = '/storefront-curation/get-curation-collection-item-list?curation_collection_id=' + collection_value.value.id + '&page=' + paged.value;

  ajax.get(api).then((response) => {

    const res = response.data.data;
    console.log(res)
    const list = res.data;
    sort_type.value = res.sort_type || 0;

    list.forEach(item => {
      items.value.push(item);
    });
    is_loading.value = false;
    is_loading_next.value = false;
    is_end.value = props.manage_type === 'post' ? true : res.last_page === paged.value;
    if (items.value.length === 0) {
      close();
    }
  });
};


const dragStart = (index, item) => {
  // log('blue', 'Drag start', index);
  drag_pre_index = index;
  is_sorting.value = true;
};

const dragEnd = (index, item) => {
  is_sorting.value = false;
  console.log('blue', 'dragEnd', item);
  let type = '';
  let ids = [];

  if (route.params.type === 'featured') {
    ids = [item.featured_id];
    type = 'featured';
  } else {
    ids = [item.product_id || item.id];
    type = item.type;
  }

  if (index !== drag_pre_index) {
    is_update_data.value = true;

    const obj = {
      ids: ids,
      direction: drag_pre_index > index ? 'up' : 'down',
      distance: drag_pre_index > index ? drag_pre_index - index : index - drag_pre_index,
      type: type,
      cb: () => {
        is_update_data.value = false;
        if (props.manage_type === 'post' || props.manage_type === 'collection') event.emit('refresh-tagged-products');
      }
    };

    if (props.manage_type === 'post') {
      obj.type = 'post-product';
      obj.post_id = props.manage_content_id;
    } else if (props.manage_type === 'collection') {
      obj.type = 'collection-product';
      obj.collection_id = props.manage_content_id;
    }

    emit('move', obj);
  }

  drag_pre_index = -1;
};

const moveItems = (direction) => {
  const ids = selected_items.value.map(item => {
    if (route.params.type === 'featured') {
      return item.featured_id;
    } else {
      return item.product_id || item.id;
    }
  });
  if (ids.length === 0) return;
  is_update_data.value = true;

  const obj = {
    ids,
    direction,
    type: route.params.type === 'featured' ? 'featured' : selected_items.value[0].type,
    cb: () => {
      is_update_data.value = false;
      if (props.manage_type === 'post' || props.manage_type === 'collection') event.emit('refresh-tagged-products');

      // move items in the list
      if (direction === 'top') {
        const selectedItems = items.value.filter(item => item.is_selected);
        const unselectedItems = items.value.filter(item => !item.is_selected);
        items.value = [...selectedItems, ...unselectedItems];
      } else if (direction === 'last') {
        const selectedItems = items.value.filter(item => item.is_selected);
        const unselectedItems = items.value.filter(item => !item.is_selected);
        items.value = [...unselectedItems, ...selectedItems];
      }

      items.value.forEach((item, index) => {
        item.is_selected = false;
      });
    }
  };

  if (props.manage_type === 'post') {
    obj.type = 'post-product';
    obj.post_id = props.manage_content_id;
  } else if (props.manage_type === 'collection') {
    obj.type = 'collection-product';
    obj.collection_id = props.manage_content_id;
  }


  emit('move', obj);
};
const deleteItems = (id = 0) => {
  const ids = [];
  let post_type = '';

  if (id !== 0) {
    post_type = 'product';
    ids.push(id);
  } else {
    selected_items.value.forEach(item => {
      post_type = item.type;
      ids.push(item.type === 'product' ? item.product_id : item.id);
    });
  }


  if (ids.length === 0) return;

  switch (props.manage_type) {
    case 'post':
      event.emit('delete-products-from-post', {
        post_id: props.manage_content_id,
        ids: ids,
        cbStart: () => {
          is_update_data.value = true;
        },
        cbEnd: () => {
          is_update_data.value = false;
          if (id !== 0) {
            items.value = items.value.filter(item => !ids.includes(item.id));
          } else {
            items.value = items.value.filter(item => !item.is_selected);
          }
        }
      });
      break;
    case 'collection':
      event.emit('delete-products-from-collection', {
        collection_id: props.manage_content_id,
        ids: ids,
        cbStart: () => {
          is_update_data.value = true;
        },
        cbEnd: () => {
          is_update_data.value = false;
          if (id !== 0) {
            items.value = items.value.filter(item => !ids.includes(item.product_id));
          } else {
            items.value = items.value.filter(item => !item.is_selected);
          }
        }
      });
      break;
    default:
      emit('delete', {
        ids,
        type: post_type,
        is_selected: ids.length > 0,
        cbStart: () => {
          is_update_data.value = true;
        },
        cbEnd: () => {
          is_update_data.value = false;
          if (id !== 0) {
            items.value = items.value.filter(item => !ids.includes(item.product_id));
          } else {
            items.value = items.value.filter(item => !item.is_selected);
          }
          emit('update');
        }
      });
      break;
  }





};

const unfeature = () => {
  const product_ids = [];
  const post_ids = [];
  const collection_ids = [];
  const ajaxs = [];
  const obj = {
    merchant_account_id: storefront.id,
    merchant_url_name: storefront.url_name,
    is_feature: 0
  };

  selected_items.value.forEach(item => {
    switch (item.type) {
      case 'product':
        product_ids.push(item.product_detail.id);
        break;
      case 'post':
        post_ids.push(item.id);
        break;
      case 'collection':
        collection_ids.push(item.id);
        break;
    }
  });


  confirm_data.value = {
    title: `Unfeature selected item(s)?`,
    description: `This will remove the product(s), Collection(s) or post(s) from your storefront homepage.`,
  };

  confirm_dialog_el.value.open();
  confirm_data.value.action = () => {
    is_update_data.value = true;

    if (product_ids.length > 0) {
      obj.product_ids = product_ids;
      ajaxs.push(ajax.post('/manage/set-product-feature-status', obj));
    }

    if (post_ids.length > 0) {
      obj.anchor_post_ids = post_ids;
      ajaxs.push(ajax.post('/manage/update-anchor-post-status', obj));
    }

    if (collection_ids.length > 0) {
      obj.anchor_collection_ids = collection_ids;
      ajaxs.push(ajax.post('/manage/set-anchor-collection-feature-status', obj));
    }

    Promise.all(ajaxs).then(() => {
      is_update_data.value = false;
      items.value = items.value.filter(item => !item.is_selected);
      emit('update');
      openNotBottom('Featured updated', 'success');
    });

  };
};

const publishItems = (action) => {
  const ids = selected_items.value.map(item => item.product_id);
  if (ids.length === 0) return;
  is_update_data.value = true;

  emit('update', {
    ids,
    action,
    cb: () => {
      is_update_data.value = false;
      items.value.forEach((item) => {
        item.is_selected = false;
      });
    }
  });
};

const chronological = (is_newest) => {
  let resource_type = 0;
  switch (route.params.type) {
    case 'products':
      resource_type = 30;
      break;
    case 'collections':
      resource_type = 20;
      break;
    case 'posts':
      resource_type = 10;
      break;
  }

  is_update_data.value = true;

  ajax('/manage/reorder-anchor-featured', {
    method: 'post',
    withCredentials: true,
    data: {
      merchant_account_id: storefront.id,
      resource_type: resource_type.toString(),
      sort: is_newest ? 'DESC' : 'ASC',
    }
  }).then(res => {
    is_update_data.value = false;
    updateData();
    emit('update');
  });

};

const open = (item) => {
  setTimeout(() => {
    is_show_drawer.value = true;
    collection_value.value = item || {};
    updateData();
  }, 100);
}

const close = () => {
  is_show_drawer.value = false;
  event.emit('open-collection-detail',collection_value.value);
}

defineExpose({
  open,
  close,
  isShow() {
    return is_show_drawer.value;
  }
})

onMounted(() => {
  event.on('openAgain-manage', updateData);
})

onBeforeUnmount(() => {
  event.off('openAgain-manage');
})
</script>

<style lang="scss">
.manage-content-drawer {
  background-color: var(--Bg-01);

  .head {
    display: flex;
    align-items: center;
    padding: 16px;
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: var(--Bg-light);

    i {
      cursor: pointer;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 4px;
      color: var(--Text-primary);
      border-radius: var(--radius);
      transition: background-color 0.2s;

      svg {
        width: 18px;
        height: 18px;
      }

      &:hover {
        background-color: var(--Neu-20);
      }
    }

    h2 {
      font: var(--medium-24);
      color: var(--Text-primary);
      flex: 1;
      padding: 0 8px;
    }

    span {
      font: var(--medium-14);
      color: var(--Text-default);
    }

    @media screen and (max-width: $mobile_size) {
      i {
        width: 22px;
        height: 22px;

        svg {
          width: 14px;
          height: 14px;
        }
      }

      h2 {
        font: var(--medium-16);
      }

      span {
        font: var(--medium-12);
      }
    }
  }

  .list-wrap {
    min-height: 300px;
    background-color: var(--Bg-01);
    padding: 24px 24px 200px;

    @media screen and (max-width: $mobile_size) {
      padding: 16px 16px 120px;
    }

    &>.ui-loading-mask {
      background-color: transparent;
    }

    .item-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 16px;

      @media screen and (max-width: $mobile_size) {
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      }

      .dnd-drag {
        // cursor: grab;
        transition: transform .2s ease;

        // &.drag-mode-reordering {
        //   cursor: grabbing;
        // }

        .drag-handle {
          cursor: grab;
        }
      }

      &.is-sorting {

        .dnd-drag {
          pointer-events: none;
          opacity: .5;

          &.drag-mode-reordering {
            opacity: 1;
          }
        }
      }
    }

    .is-end {
      color: var(--Text-default);
      text-align: center;
      padding: 48px 0;
    }

    .load-more {
      display: flex;
      justify-content: center;
      padding: 48px 0 32px;

      .el-button {
        padding: 0 24px;
      }
    }
  }

  .manage-page-tools {
    left: 0;
  }

  .ui-drawer__header {
    display: none;
  }

  .ui-drawer__body {
    padding: 0;
  }
}

.manage-content-collection,
.manage-content-post {
  width: 90% !important;

  .manage-page-tools {
    left: 10%;
  }
}
</style>